type GetYTicksParams = {
  lastTick: number;
  firstTick: number;
  numOfMiddleTicks: number;
};

export const getYTicks = ({
  firstTick,
  lastTick,
  numOfMiddleTicks,
}: GetYTicksParams) => {
  const ticksArray = Array.from({ length: numOfMiddleTicks }, (_, i) => {
    return (
      firstTick + ((lastTick - firstTick) / (numOfMiddleTicks + 1)) * (i + 1)
    );
  });
  const baseTicks = [firstTick, ...ticksArray, lastTick];
  const ticks = baseTicks.includes(0) ? baseTicks : [0, ...baseTicks];
  return ticks;
};
